/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function AlignTop(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Rect
        x={116}
        y={100}
        width={112}
        height={56}
        rx={8}
        transform="translate(300 -44) rotate(90)"
        opacity={0.2}
      />
      <Rect x={56} y={72} width={56} height={152} rx={8} opacity={0.2} />
      <Line
        x1={216.00488}
        y1={39.99414}
        x2={40.00488}
        y2={39.99414}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Rect
        x={116}
        y={100}
        width={112}
        height={56}
        rx={8}
        transform="translate(300 -44) rotate(90)"
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Rect
        x={56}
        y={72}
        width={56}
        height={152}
        rx={8}
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  );
}

export default AlignTop;
